import PT from 'prop-types';
import { useEffect, useState } from 'react';

// mui imports
import { Collapse, List, Typography, Box } from '@mui/material';

import { NavLink, useLocation } from 'react-router-dom';

// icons
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

const MenuItem = props => {
  const { name, items, id, shortname } = props || {};
  let { link } = props || {};
  const nested = items && items.length > 0;
  const location = useLocation();
  const [active, setActive] = useState('');
  const [toggle, setToggle] = useState(false);

  const handleToggle = () => setToggle(!toggle);

  let routes = location.pathname.split('/');

  if (
    (link == undefined && name === 'Test Courses') ||
    (link == undefined && shortname === 'T1234')
  ) {
    link = '/courses';
  }

  useEffect(() => {
    let routeName = routes[routes.length - 1];
    let str2 = routeName.charAt(0).toUpperCase() + routeName.slice(1);
    str2 = str2.replace('%20', ' ');
    setActive(str2);
  }, [location.pathname]);

  const MenuItemParent = () => {
    const commonProperties = {
      display: 'flex',
      alignItems: 'center'
    };

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}>
        {nested ? (
          <Box
            as="span"
            sx={{
              ...commonProperties,
              color: 'dark.main',
              fontSize: '1.2rem',
              cursor: 'pointer'
            }}
            onClick={handleToggle}>
            {toggle ? (
              <FaAngleDown size={20} />
            ) : (
              <FaAngleUp
                style={{
                  transform: 'rotate(90deg)'
                }}
                size={20}
              />
            )}
            <Typography
              sx={{
                '&:hover': {
                  color: 'steelblue',
                  fontWeight: 'bold'
                },
                fontSize: '16px',
                marginLeft: 0.5,
                color: active === name ? 'steelblue' : '',
                fontWeight: active === name ? 'bold' : ''
              }}
              as="span"
              variant="link">
              {name ? name : shortname}
            </Typography>
          </Box>
        ) : (
          <NavLink
            to={`${link ? link : '#'}`}
            state={{
              id,
              title: name ? name : shortname,
              type: shortname && true
            }}>
            <Typography
              sx={{
                '&:hover': {
                  color: 'steelblue',
                  fontWeight: 'bold'
                },
                fontSize: '16px',
                marginLeft: 0.5,
                color: active === name ? 'steelblue' : '',
                fontWeight: active === name ? 'bold' : ''
              }}
              as="h6"
              variant="link">
              {name ? name : shortname}
            </Typography>
          </NavLink>
        )}
      </Box>
    );
  };

  return (
    <>
      <MenuItemParent />
      {nested ? <NestedMenuItem toggle={toggle} items={items} /> : null}
    </>
  );
};

const NestedMenuItem = props => {
  return (
    <Collapse in={props.toggle} timeout="auto" unmountOnExit sx={{ ml: 1.5 }}>
      <List as="nav">
        {props.items.map((item, index) => {
          return <MenuItem id={item.id} {...item} key={index} />;
        })}
      </List>
    </Collapse>
  );
};

MenuItem.propTypes = {
  name: PT.string,
  link: PT.string,
  items: PT.arrayOf(PT.object)
};

NestedMenuItem.propTypes = {
  toggle: PT.bool.isRequired,
  items: PT.arrayOf(PT.object)
};

export default MenuItem;
